import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import {
    HasParentOrderedDuringActiveMonth,
    ResetOrdersDuringActiveMonth,
    SetParentHomeworkReservationInActiveMonth,
    SetParentMealReservationInActiveMonth,
} from '../actions/orders.action';

export interface OrdersStateModel {
    hasHomeworkOrders: boolean;
    hasMealOrders: boolean;
}

@State<OrdersStateModel>({
    name: 'orders',
    defaults: {
        hasHomeworkOrders: false,
        hasMealOrders: false,
    },
})
@Injectable()
export class OrdersState {
    @Selector()
    public static hasHomeworkOrders(state: OrdersStateModel): boolean {
        return state.hasHomeworkOrders;
    }

    @Selector()
    public static hasMealOrders(state: OrdersStateModel): boolean {
        return state.hasMealOrders;
    }

    @Action(HasParentOrderedDuringActiveMonth)
    public hasOrdersDuringActiveMonth(ctx: StateContext<OrdersStateModel>, action: HasParentOrderedDuringActiveMonth): void {
        ctx.patchState({
            hasMealOrders: action.hasMealOrders,
            hasHomeworkOrders: action.hasHomeworkOrders,
        });
    }

    @Action(SetParentMealReservationInActiveMonth)
    public setParentMealReservationInActiveMonth(ctx: StateContext<OrdersStateModel>): void {
        ctx.patchState({
            hasMealOrders: true,
        });
    }

    @Action(SetParentHomeworkReservationInActiveMonth)
    public setParentHomeworkReservationInActiveMonth(ctx: StateContext<OrdersStateModel>): void {
        ctx.patchState({
            hasHomeworkOrders: true,
        });
    }

    @Action(ResetOrdersDuringActiveMonth)
    public resetOrdersDuringActiveMonth(ctx: StateContext<OrdersStateModel>): void {
        ctx.patchState({
            hasMealOrders: false,
            hasHomeworkOrders: false,
        });
    }
}
